import type { LucideIcon } from 'lucide-react';
import { Globe, Mail, MapPin, Printer } from 'lucide-react';

import {
  DestinationChannelType,
  DestinationScope,
  VerificationStatus,
} from '@/types/provider-destinations';

export const SCOPE_LABELS: Record<DestinationScope, string> = {
  [DestinationScope.RECORDS]: 'Records',
  [DestinationScope.BILLS]: 'Bills',
  [DestinationScope.RADIOLOGY]: 'Radiology',
  [DestinationScope.ER_PHYSICIAN]: 'ER Physician',
};

export const CHANNEL_LABELS: Record<DestinationChannelType, string> = {
  [DestinationChannelType.FAX]: 'Fax',
  [DestinationChannelType.EMAIL]: 'Email',
  [DestinationChannelType.MAIL]: 'Mail',
  [DestinationChannelType.PORTAL]: 'Portal',
};

export const CHANNEL_ICONS: Record<DestinationChannelType, LucideIcon> = {
  [DestinationChannelType.FAX]: Printer,
  [DestinationChannelType.EMAIL]: Mail,
  [DestinationChannelType.MAIL]: MapPin,
  [DestinationChannelType.PORTAL]: Globe,
};

export const VERIFICATION_BADGE_COLORS: Record<VerificationStatus, string> = {
  [VerificationStatus.VERIFIED]: 'bg-emerald-100 text-emerald-800',
  [VerificationStatus.PENDING]: 'bg-yellow-100 text-yellow-800',
  [VerificationStatus.UNVERIFIED]: 'bg-zinc-100 text-zinc-800',
  [VerificationStatus.DISPUTED]: 'bg-red-100 text-red-800',
  [VerificationStatus.ARCHIVED]: 'bg-gray-100 text-gray-600',
};

export function formatLastSuccess(
  date: string | null | undefined,
): string {
  if (!date) return 'No previous success';

  const now = new Date();
  const then = new Date(date);
  const diffMs = now.getTime() - then.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 30) return `${diffDays}d ago`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)}mo ago`;
  return `${Math.floor(diffDays / 365)}y ago`;
}
